import type { FC, ReactNode } from 'react';
import cx from 'classnames';

import styles from './ModalBody.module.scss';

interface ModalBodyProps {
	children: ReactNode;
	className?: string;
}

export const ModalBody: FC<ModalBodyProps> = ({ children, className }) => {
	return <div className={cx(styles.body, className)}>{children}</div>;
};
